import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import Accordion from '@material-ui/core/Accordion'
import AccordionSummary from '@material-ui/core/AccordionSummary'
import AccordionDetails from '@material-ui/core/AccordionDetails'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import { makeStyles } from '@material-ui/core'

const styles = {
  root: {
    padding: 0,
    'align-items': 'end',
    minHeight: 0,
    maxHeight: 25,
  },
  AccordionSummaryContent: {
    margin: 0,
  },
  AccordionSummaryExpandIcon: {
    paddingTop: 0,
  },
}

const useStyle = makeStyles(theme => ({
  root: {
    padding: '8px 0px',
  },
}))

function SimpleAccordion(props) {
  const { classes, title, content, className } = props
  const classesStyles = useStyle()
  return (
    <div>
      <Accordion className={className} elevation={0}>
        <AccordionSummary
          classes={{
            root: classes.root,
            content: classes.AccordionSummaryContent,
            expandIcon: classes.AccordionSummaryExpandIcon,
          }}
          expandIcon={<ExpandMoreIcon />}
        >
          {title}
        </AccordionSummary>
        <AccordionDetails classes={{ root: classesStyles.root }}>{content}</AccordionDetails>
      </Accordion>
    </div>
  )
}

export default withStyles(styles)(SimpleAccordion)
